import { HeaderContain } from './Header.styles';
import Images from 'src/App/Images';

export function Header() {
	return (
		<HeaderContain>
			<a href="https://lumiastream.com" target="_blank">
				<Images.LogoTitle title="Lumia Logo" />
			</a>
		</HeaderContain>
	);
}
